var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitPointLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9036",
    "data-name": "Group 9036",
    transform: "translate(-20 -784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M29.333,33.369l-5.222-5.222a1.5,1.5,0,0,1,2.121-2.121l3.1,3.1,7.784-7.784a1.5,1.5,0,0,1,2.121,2.121Z",
    transform: "translate(5.214 774.37)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    d: "M17,2A15,15,0,0,0,6.393,27.607,15,15,0,1,0,27.607,6.393,14.9,14.9,0,0,0,17,2m0-2A17,17,0,1,1,0,17,17,17,0,0,1,17,0Z",
    transform: "translate(20 784)",
    fill: "#333a4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitPointLogo);
export default __webpack_public_path__ + "static/media/benefitPointLogo.5ffeb0c19d969c67bb4c8d6e5672ebbc.svg";
export { ForwardRef as ReactComponent };